// BL-119 — Doc branding helpers shared by the reader (DocPreview) and the
// Design settings panel (DocDesignModal). A doc's `branding` object drives the
// published look: logo, brand name, accent, font, per-section backgrounds, and
// the header search / auth toggles.

// Curated Google Fonts offered in the font picker. `value` is the family name
// exactly as Google Fonts expects it; '' means the app default (self-hosted).
export const DOC_FONTS = [
  { label: 'Default', value: '' },
  { label: 'Inter', value: 'Inter' },
  { label: 'Roboto', value: 'Roboto' },
  { label: 'Open Sans', value: 'Open Sans' },
  { label: 'Lato', value: 'Lato' },
  { label: 'Montserrat', value: 'Montserrat' },
  { label: 'Poppins', value: 'Poppins' },
  { label: 'Source Sans 3', value: 'Source Sans 3' },
  { label: 'Nunito', value: 'Nunito' },
  { label: 'Work Sans', value: 'Work Sans' },
  { label: 'DM Sans', value: 'DM Sans' },
  { label: 'IBM Plex Sans', value: 'IBM Plex Sans' },
  { label: 'Raleway', value: 'Raleway' },
  { label: 'Rubik', value: 'Rubik' },
  { label: 'Merriweather (serif)', value: 'Merriweather' },
  { label: 'Playfair Display (serif)', value: 'Playfair Display' }
];

// Default per-section background colours (match the reader's base palette).
export const BRANDING_DEFAULTS = {
  accent: '#0E8A8E',
  nav_color: '#5A6B7E',
  nav_sub_color: '#5A6B7E',
  bg_header: '#FFFFFF',
  bg_left: '#FBFCFC',
  bg_center: '#FFFFFF',
  bg_right: '#FFFFFF'
};

// Inject a Google Fonts stylesheet <link> once per family. Safe to call on
// every render / selection — it no-ops if the family is empty or already loaded.
export const loadGoogleFont = (family) => {
  if (!family || typeof document === 'undefined') return;
  const id = `gf-${family.replace(/\s+/g, '-').toLowerCase()}`;
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${family.replace(/\s+/g, '+')}:wght@400;500;600;700;800&display=swap`;
  document.head.appendChild(link);
};

// CSS font-family stack for a chosen family (undefined -> app default applies).
export const fontStack = (family) => (
  family ? `'${family}', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif` : undefined
);

// Build the inline CSS-variable style object the reader applies at its root.
export const brandingStyle = (brand = {}) => {
  const style = {};
  if (brand.accent) style['--r-accent'] = brand.accent;
  if (brand.nav_color) style['--r-nav'] = brand.nav_color;
  if (brand.nav_sub_color) style['--r-nav-sub'] = brand.nav_sub_color;
  const ff = fontStack(brand.font);
  if (ff) style['--r-font'] = ff;
  if (brand.bg_header) style['--r-bg-header'] = brand.bg_header;
  if (brand.bg_left) style['--r-bg-left'] = brand.bg_left;
  if (brand.bg_center) style['--r-bg-center'] = brand.bg_center;
  if (brand.bg_right) style['--r-bg-right'] = brand.bg_right;
  return style;
};
